export default __webpack_public_path__ + "static/media/restaurant_grey.24641d14.svg";